/* eslint-disable no-nested-ternary */
import React, { useContext, useState, useEffect } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useTheme } from '@material-ui/core/styles';
import { GlobalContext } from '@mummssoftware/global-context';
import { AgGridTableWrapper } from '@mummssoftware/common-ui';
import { FormsContext } from '../../context';
import { EditCellRenderer, CreatedByCell } from './CellRenderer';
import { smallColumnTableDefs, expandedColumnTableDefs } from './columnDefs';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';

const frameworkComponents = {
  editCellRenderer: EditCellRenderer,
  createdByCell: CreatedByCell,
};

export const ListForms = () => {
  const {
    props: { grid: gridTheme },
  } = useTheme() as any;

  const {
    smallWidget,
    agency,
    siteId,
    onWidgetReady,
    getInProgressForms,
  } = useContext(FormsContext);
  const { crossPatientWIPForms } = useContext(GlobalContext);

  useEffect(() => {
    // only time GlobalContext is updated is when deleting a form or submit
    !crossPatientWIPForms && getInProgressForms(agency as string, siteId);
  }, []);

  useEffect(() => {
    if (crossPatientWIPForms) {
      onWidgetReady && onWidgetReady('Forms' as mumms.ComponentName);
      console.log('## FORMS IN PROGRESS WIDGET END ##', new Date());
    }
  }, [crossPatientWIPForms]);

  const columnTableDefs = smallWidget
    ? smallColumnTableDefs
    : expandedColumnTableDefs;

  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: true,
      filter: true,
    },
    columnDefs: columnTableDefs,
    // onCellClicked: (event: CellClickedEvent) => {
    //   setTimeout(() => {
    //     gridApi && gridApi.clearFocusedCell();
    //   }, 500);
    // },
    onGridReady: (params: any) => {
      const gridAPI: GridApi = params.api;
      setGridApi(gridAPI);
      gridAPI.sizeColumnsToFit();
    },
  };

  return (
    <>
      <AgGridTableWrapper
        id="list-forms-wrapper"
        className={`${gridTheme.className} light hover`}
      >
        <AgGridReact
          gridOptions={gridOptions}
          rowData={crossPatientWIPForms || []}
          rowHeight={gridTheme.rowHeight}
          headerHeight={gridTheme.headerHeight}
          frameworkComponents={frameworkComponents}
        />
      </AgGridTableWrapper>
    </>
  );
};
